export default __webpack_public_path__ + "static/emerging-industries-cdc7ece976a20969df3998a3989153e8.png";